import React from 'react'
import { motion } from 'framer-motion'
import { useAppStore } from '@/hooks/useAppStore'
import { Topbar } from '@/components/shared/Topbar'
import { Atmosphere } from '@/components/shared/Atmosphere'

export function ModeScreen() {
  const setScreen = useAppStore((s) => s.setScreen)

  return (
    <div style={{
      minHeight: '100vh',
      background: 'radial-gradient(ellipse at 50% 20%, #3A2312 0%, #241209 55%, #180C05 100%)',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    }}>
      <Atmosphere count={16} />
      <div style={{ position: 'relative', zIndex: 5 }}>
        <Topbar backTo="welcome" />
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 20px', position: 'relative', zIndex: 3, textAlign: 'center' }}>
        <div style={{ fontFamily: 'var(--serif-caps)', fontSize: 10, letterSpacing: '0.2em', color: 'rgba(245,237,216,0.5)', textTransform: 'uppercase', marginBottom: 14 }}>
          Welcome to Passage
        </div>
        <motion.h1
          initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          style={{ fontFamily: 'var(--serif-display)', fontSize: 'clamp(28px, 5vw, 42px)', color: '#F5EDD8', marginBottom: 12, maxWidth: 640 }}
        >
          How would you like to <em style={{ color: 'var(--gold2)' }}>travel</em> with us?
        </motion.h1>
        <p style={{ fontFamily: 'var(--serif-body)', fontSize: 15, fontStyle: 'italic', color: 'rgba(245,237,216,0.62)', marginBottom: 44, maxWidth: 440 }}>
          Our guide will discover your Travel DNA — and the destinations that befit it.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 18, width: '100%', maxWidth: 660 }}>
          {/* Speak — coming soon, non-interactive */}
          <div
            style={{
              border: '1px solid rgba(212,160,23,0.18)', borderRadius: 4,
              background: 'rgba(255,255,255,0.03)', padding: '32px 26px',
              opacity: 0.55, cursor: 'not-allowed', position: 'relative', textAlign: 'left',
            }}
            aria-disabled="true"
          >
            <div style={{
              position: 'absolute', top: 14, right: 14,
              fontFamily: 'var(--serif-caps)', fontSize: 8, letterSpacing: '0.1em',
              color: 'var(--espresso)', background: 'var(--gold2)', padding: '3px 9px', textTransform: 'uppercase', borderRadius: 2,
            }}>
              Coming Soon
            </div>
            <div style={{
              width: 52, height: 52, borderRadius: '50%', border: '1px solid rgba(196,149,106,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, marginBottom: 18, color: 'var(--warm)',
            }}>
              🎙
            </div>
            <div style={{ fontFamily: 'var(--serif-display)', fontSize: 20, color: '#F5EDD8', marginBottom: 8 }}>Speak</div>
            <p style={{ fontFamily: 'var(--serif-body)', fontSize: 13, color: 'rgba(245,237,216,0.55)', lineHeight: 1.7, marginBottom: 16 }}>
              Have a natural conversation with our guide. Just talk — Passage listens.
            </p>
            <span style={{ fontFamily: 'var(--serif-caps)', fontSize: 9, letterSpacing: '0.1em', color: 'var(--warm)', border: '1px solid rgba(196,149,106,0.3)', padding: '4px 12px', textTransform: 'uppercase' }}>
              Voice · AI
            </span>
          </div>

          {/* Tap & Type — proceeds to quiz */}
          <motion.button
            onClick={() => setScreen('quiz')}
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.98 }}
            className="p-glow-card"
            style={{
              border: '1px solid rgba(212,160,23,0.5)', borderRadius: 4,
              background: 'rgba(212,160,23,0.07)', padding: '32px 26px',
              cursor: 'pointer', textAlign: 'left', position: 'relative',
            }}
          >
            <div style={{
              width: 52, height: 52, borderRadius: '50%', border: '1px solid rgba(212,160,23,0.5)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, marginBottom: 18, color: 'var(--gold2)',
            }}>
              ◈
            </div>
            <div style={{ fontFamily: 'var(--serif-display)', fontSize: 20, color: '#F5EDD8', marginBottom: 8 }}>Tap &amp; Type</div>
            <p style={{ fontFamily: 'var(--serif-body)', fontSize: 13, color: 'rgba(245,237,216,0.68)', lineHeight: 1.7, marginBottom: 16 }}>
              Choose guided options or write freely. Elegant, visual, unhurried.
            </p>
            <span style={{ fontFamily: 'var(--serif-caps)', fontSize: 9, letterSpacing: '0.1em', color: 'var(--gold2)', border: '1px solid rgba(212,160,23,0.5)', padding: '4px 12px', textTransform: 'uppercase' }}>
              Touch · Text
            </span>
          </motion.button>
        </div>
      </div>
    </div>
  )
}
